module.exports = __webpack_public_path__ + "static/img/bg-es.53a5391f.webp";